<template>
    <transition name="slide-fade">
        <div v-if="visible" class="bounced-mail">
            <div class="bounced-mail-title primary white--text mb-1 v-flex">
                <div class="ml-4">
                    {{ title }}
                </div>
                <v-spacer />
                <div class="v-flex">
                    <div class="v-flex white pl-2 pr-1 mr-4  bounced-mail-commit">
                        <div class="primary--text">
                            Mail bestätigt
                        </div>
                        <div>
                            <v-checkbox
                                v-model       = "mail.confirmed"
                                class         = "ma-0 pa-0 mr-n2"
                                :ripple       = "false"
                                :hide-details = "true"
                                @click.native.capture = "onClickConfirmed"
                                @change               = "onConfirmed"
                                dense
                            />
                        </div>
                    </div>

                    <c-toolbar-button
                        :ripple = "false"
                        v-if    = "mail.incidentId"
                        icon    ="mdi-arrow-right-thin-circle-outline"
                        color   ="white"
                        size    = "22"
                        tooltip = "Zum Ereignis wechseln"
                        @click  = "onGoto"
                    />

                    <c-toolbar-button
                        :ripple = "false"
                        icon    ="mdi-close"
                        color   ="white"
                        size    = "22"
                        tooltip = "Mail schliessen"
                        @click  = "onClose"
                    />
                </div>
            </div>

            <div class="lm-border bounced-mail-header pa-3 w-100 h-100">
                <div class="mail-addr">
                    <div class="label primary white--text">Von</div>
                    <div class="data mail-receiver"> {{ mail.sender }}</div>
                </div>
                <div class="mail-addr">
                    <div class="label primary white--text">Empfänger</div>
                    <div class="data mail-receiver"> {{ mail.receiver }}</div>
                </div>
                <div class="mail-addr">
                    <div class="label primary white--text">Betreff</div>
                    <div class="mail-subject">{{ mail.subject }}</div>
                </div>
            </div>

            <div class  = "lm-border bounced-mail-body mt-2 pa-3" :style="heightStyle">
                <div v-html="body">
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PIncBouncedMail",

    components: {
        CToolbarButton
    },

    props: {
        value: {

        },

        bouncedMail: {

        },

        height: {

        }
    },

    data: () => ({
        visible: false,
    }),

    mounted() {
        this.visible = this.value;
    },

    watch: {
        value () {
            this.visible = this.value;
        },

        visible () {
            if (!this.visible) {
                this.$emit ("input", false)
            }
        }
    },

    computed: {
        mail () {
            console.log("baunced", this.bouncedMail)
            return this.bouncedMail.mail;
        },

        title() {
            return this.bouncedMail.title;
        },

        heightStyle () {
            return "height: " + (this.height-260) + "px; max-height:" + (this.height-260) + "px;";
        },


        from () {
            if (this.mail.replyTo) {
                let from = "";
                this.mail.replyTo.forEach ((reply, index) => {
                    from = from + reply.name + ' (' + reply.email + ')'
                    if (index < this.mail.replyTo.length-1) {
                        from = from + "; ";
                    }
                });

                return from;
            }

            if (this.mail.from) {
                return this.mail.from.name + " (" + this.mail.from.email +")";
            }

            return null;
        },

        body () {
            const styleStart = this.mail.body.indexOf ("<style");
            const styleEnd   = this.mail.body.indexOf ("</style>");

            if (styleStart >= 0 && styleEnd >= 0) {
                return this.mail.body.substr(0, styleStart-1) + this.mail.body.substr(styleEnd+8);
            }

            return this.mail.body;
        }
    },

    methods: {
        onGoto () {
            Inc.goto(this, this.mail.incidentId, null);
        },

        onClose () {
            this.$emit("input", false);
        },

        onClickConfirmed () {

        },

        onConfirmed () {
            Inc.todo.bounce.confirm (this.mail.id, this.mail.confirmed);
        }
    }
}
</script>

<style scoped>

.bounced-mail {
    background: white;
    position: absolute;
    z-index: 10;
    top: 128px;
    left: calc(20% + 40px);
    width: calc(80% - 100px);
}

.bounced-mail-title {
    height: 30px;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    padding-top: 3px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.bounced-mail-commit {
    height: 28px;
    max-height: 25px;
    border-radius: 3px;
}

.bounced-mail-header {
    background: white;
}

.bounced-mail-header .label {
    width: 100px;
    height: 30px;
    font-size: 15px;
    padding-left: 8px;
    padding-top: 3px;
    border-radius: 4px;
    margin-right: 8px;
}

.bounced-mail-body {
    overflow-y: scroll;
    overflow-x: hidden;
    font-size: 15px;
}

.mail-subject {
    max-width: calc(100% - 108px);
    padding-top: 1px!important;
    font-size: 15px;
    padding-left: 0;
    height: 65px;
    max-height: 45px;
    overflow-y: scroll;
}

.mail-addr {
    display: flex;
    margin-top: 5px;
}

.mail-receiver {
    padding-top: 3px;
}


</style>